export class AchievementCache {
  constructor(obj) {
    this.cache = obj
    this.dirtyFlag = false
  }

  getCache(type) {
    return this.cache[type] || {}
  }

  setCache(type, obj) {
    this.dirtyFlag = true
    return this.cache[type] = obj
  }

  isDirty() {
    return this.dirtyFlag
  }

  flush() {
    this.dirtyFlag = false
    return this.cache
  }
}



// WEBPACK FOOTER //
// ./src/components/common/achievement/AchievementCache.js